// Static image URLs supplied by the design agent. Do NOT replace with placeholders.
export const IMAGES = {
  hero_product: "/numa-bottle.webp",
  hero_product_macro: "/hero-numa-capsule.jpg",
  hero_product_alt:
    "https://static.prod-images.emergentagent.com/jobs/d892c18e-0db7-4c3f-8e56-fbfc0c6ef23b/images/07adbda41ddbcd081779ec4ed8305dcd0282d6928698b8421151f8be1464e563.png",
  capsule_macro: "/delivery-capsule.png",
  capsule_macro_alt:
    "https://static.prod-images.emergentagent.com/jobs/d892c18e-0db7-4c3f-8e56-fbfc0c6ef23b/images/f9fe64c928eb1e1868f53f89f8946c437d32fc29fc8a97be52307e5398289def.png",
  packaging_detail:
    "https://static.prod-images.emergentagent.com/jobs/d892c18e-0db7-4c3f-8e56-fbfc0c6ef23b/images/5c44069ef8cb18b6c4ebb7d48c33654926ed8b7c0d696cc5744a6cc007a7cf2e.png",
  clinical_environment:
    "https://static.prod-images.emergentagent.com/jobs/d892c18e-0db7-4c3f-8e56-fbfc0c6ef23b/images/325bbdebfc8b1413ddbcb3eafd01d8996032ee9b8cef8aee7b4643ef8b163955.png",
};

export const fadeIn = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};
